import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { useChurchStore } from "features/churches";
import { useDenominationStore } from "features/denominations";
import { useStoredMessagesStore } from "features/messages";
import { useFormPersistence } from "hooks/useFormPersistence";
import { useSignOut } from "react-auth-kit";
import { useCentralStore } from "stores";
import { Button } from "../Buttons";

export const SignOutModal = () => {
  const signOutModalOpen = useCentralStore(state => state.signOutModalOpen);
  const closeSignOutModal = useCentralStore(state => state.closeSignOutModal);
  const selectChurch = useChurchStore(state => state.selectChurch);
  const selectDenomination = useDenominationStore(
    state => state.selectDenomination
  );
  const storeMessages = useStoredMessagesStore(state => state.storeMessages);

  const signOut = useSignOut();
  const queryClient = useQueryClient();
  const { clearFormData } = useFormPersistence();

  const clearLocalStorageData = () => {
    selectChurch(null);
    selectDenomination(null);
    storeMessages([]);
  };

  const handleSignOut = () => {
    queryClient.clear();
    clearLocalStorageData();
    clearFormData();
    signOut();
    closeSignOutModal();
  };

  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      open={signOutModalOpen}
      sx={{
        backdropFilter: "blur(10px)"
      }}
    >
      <DialogTitle>Session Expired</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Your session has ended. To continue using the application, please sign
          in again.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleSignOut}>Sign In Again</Button>
      </DialogActions>
    </Dialog>
  );
};
